export default {
  alugueisAtrasados: false,
  contatoComCliente: false,
  quantidadeImoveisCadastrados: false,
  desempenhoMensal: false,
  receitaAluguel: false,
  repasseAluguel: false,
  receitaAluguelDiario: false,
  resumoImoveisAluguel: false,
  ultimaCaptacaoAluguel: false,
  repassesDoDia: false,
  repassesAtrasados: false,
  ultimaCaptacaoVenda: false,
  visitasAgendadas: false,
  solicitacoesParceria: false,
  ultimasTabelasEmpreendimentos: false,
  contratosVencidos: false,
  contatosPretendentes: false,
  contasPagarDoDia: false,
  contasPagarAtrasadas: false,
  alugueisDoDia: false,
  contratosReajuste: false,
  contratosRenovar: false,
};